import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { BRAND, LOGO_URL, PHONE_DISPLAY, PHONE_TEL, TAGLINE } from "../../data/menu";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative bg-[#e63946] text-black overflow-hidden"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col items-start gap-8">
          <div className="inline-block rounded-xl bg-black p-4 md:p-5 shadow-[0_10px_40px_rgba(0,0,0,0.35)]">
            <img
              src={LOGO_URL}
              alt={BRAND}
              className="h-24 md:h-36 w-auto object-contain"
            />
          </div>
          <p className="font-accent uppercase tracking-wide text-xl md:text-3xl text-white">
            {TAGLINE}
          </p>

          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="footer-call-number"
            className="block font-display uppercase leading-[0.85] tracking-tight text-[13vw] md:text-[9vw] text-black hover:text-white transition-colors duration-300"
          >
            {PHONE_DISPLAY}
          </a>

          <motion.a
            href={`tel:${PHONE_TEL}`}
            data-testid="footer-call-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            className="group inline-flex items-center gap-3 rounded-full bg-black px-8 py-4 font-accent uppercase tracking-wide text-white text-lg transition-colors duration-300 hover:bg-[#0a0a0a] focus:outline-none focus:ring-2 focus:ring-black"
          >
            <Phone className="h-5 w-5 transition-transform group-hover:rotate-12" />
            Call Now
          </motion.a>
        </div>

        <div className="mt-16 border-t border-black/20 pt-8 flex flex-col md:flex-row justify-between gap-4 font-body uppercase tracking-widest text-xs text-black/70">
          <span>© {new Date().getFullYear()} {BRAND}</span>
          <div className="flex items-center gap-6">
            <span>Home Catering • Spaghetti • Wings • Beans</span>
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="text-black/60 hover:text-black transition-colors"
            >
              Owner
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
